export default function () {
  return {
    is_user_logged_in: false,
    user: {},
    token: "",
    watchlistActiveCount: 0,
  };
}
